module.exports = __webpack_public_path__ + "static/media/infoJumbo2.7a3abd83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/fehlmann/images/infoJumbo2.jpg
// module id = 484
// module chunks = 0